export const headerContent = {
  navigation: [{ label: 'о проекте', href: ' https://prichal-dom.ru/about' }],
  menu: 'меню',
  cta: {
    label: 'выбрать квартиру',
    href: '#contacts',
  },
  layoutsMenu: [
    { label: 'на плане', href: 'https://prichal-dom.ru/genplan' },
    { label: 'по параметрам', href: 'https://prichal-dom.ru/search/params' },
    { label: 'по номеру', href: '#number' },
  ],
  phone: {
    label: '+7 (495) 123-45-67',
    href: 'tel:+74951234567',
  },
  buttonLabel: 'выбрать квартиру',
  buttonHref: 'https://prichal-dom.ru/genplan',
};
